import { render, staticRenderFns } from "./SelectedStudentCompact.vue?vue&type=template&id=4fb760fc&scoped=true"
import script from "./SelectedStudentCompact.vue?vue&type=script&lang=js"
export * from "./SelectedStudentCompact.vue?vue&type=script&lang=js"
import style0 from "./SelectedStudentCompact.vue?vue&type=style&index=0&id=4fb760fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb760fc",
  null
  
)

export default component.exports